import useBetaFeatures from "../../../betaFeatures/useBetaFeatures";
import PatientsDashboardEndpointRoute from "./PatientsDashboardEndpointRoute";
import PatientsDashboardGraphQLRoute from "./PatientsDashboardGraphQLRoute";

/**
 * Picks which patients list to render.
 *
 * The endpoint list asks the server for one page at a time. The GraphQL list is
 * the one it replaced, kept behind the beta switch so anyone who hits a problem
 * with the new one can get their work done while it is fixed.
 *
 * Two whole implementations rather than one parameterised by the flag: they
 * differ in where every filter, sort and page comes from, and interleaving that
 * would leave neither readable. The pair is meant to be temporary — when the
 * switch goes, the GraphQL file goes with it.
 */
export default function PatientsDashboardRoute() {
  const [features] = useBetaFeatures();

  return features.patientMemoryImprovements ? (
    <PatientsDashboardEndpointRoute />
  ) : (
    <PatientsDashboardGraphQLRoute />
  );
}
